(function () {
    'use strict';

    angular
     .module('surveyCampaignsModule')
     .controller('SurveyCampaignStaticTextEditController', Controller);

    Controller.$inject = ['$scope', '$state', '$window', 'questionnaireTemplate', 'questionnaireSection', 'campaign',
        'oddStaticText', 'oddSurveyQuestionnaireTemplateService', 'notificationService', 'marked'];

    function Controller($scope, $state, $window, questionnaireTemplate, questionnaireSection, campaign,
                        oddStaticText, oddSurveyQuestionnaireTemplateService, notificationService, marked) {

        // scroll to top of the page on init.
        $window.scrollTo(0, 0);

        $scope.questionnaireTemplate = questionnaireTemplate;
        $scope.questionnaireSection = questionnaireSection;
        $scope.campaign = campaign;
        $scope.ctrlCtxt = {
            questionnaireTemplateStaticText: oddStaticText
        };

        if (!$scope.ctrlCtxt.questionnaireTemplateStaticText.ItemTypeCode) {
            $scope.ctrlCtxt.questionnaireTemplateStaticText.ItemTypeCode = 'ODDStaticText';
        }

        // Go To Questionnaire Template
        $scope.goToSurveyCampaign = function (campaign) {
            $state.go('odd.surveyCampaignEdit', {
                ODDCampaignID: campaign.ODDCampaignID
            }, {
                reload: true
            });
        };
        $scope.goToCampaigns = function () {
            $state.go('odd.surveyCampaigns', {
                ODDBusinessUnitID: $scope.campaign.ODDBusinessUnitID
            }, {
                reload: true
            });
        };

        // Delete Static Text
        $scope.delete = function (staticText) {
            $scope.ctrlCtxt.isLoading = true;

            oddSurveyQuestionnaireTemplateService
             .deleteStaticText($scope.campaign.ODDBusinessUnitID,
              questionnaireSection.ODDQuestionnaireID,
              questionnaireSection.ODDSectionID,
              staticText.ODDStaticTextID).then(function () {
                  notificationService.notify('Static Text has been deleted');
                  $state.go('odd.surveyCampaignEdit.section', {
                      ODDQuestionnaireID: questionnaireSection.ODDQuestionnaireID,
                      ODDSectionID: questionnaireSection.ODDSectionID
                  }, {
                      reload: true
                  });
              })
             .finally(function () {
                 $scope.ctrlCtxt.isLoading = false;
             });
        };

        // Create Or Update
        $scope.createOrUpdate = function (staticText) {
            $scope.boxModel = staticText;

            if ($scope.boxModel.Content === "") {
                $scope.ctrlCtxt.showSubmitError = true;
                $scope.ctrlCtxt.isFormInvalidMsgShow = true;

                $timeout(function () {
                    $scope.ctrlCtxt.isFormInvalidMsgShow = false;
                }, govNotificationDelay);

                return;
            }

            $scope.ctrlCtxt.isFormInvalidMsgShow = false;
            $scope.ctrlCtxt.showSubmitError = false;
            $scope.ctrlCtxt.isLoading = true;

            // Create StaticText
            if (!staticText.ODDStaticTextID) {

                oddSurveyQuestionnaireTemplateService
                 .createStaticText(campaign.ODDBusinessUnitID,
                  $scope.questionnaireSection.ODDQuestionnaireID,
                  $scope.questionnaireSection.ODDSectionID,
                  $scope.boxModel)
                 .then(function (createdStaticText) {
                     notificationService.notify('The Static Text was created');
                     $state.go('odd.surveyCampaignEdit.section.staticTextEdit', {
                         ODDStaticTextID: createdStaticText.ODDStaticTextID
                     }, {
                         reload: true
                     });
                 }).finally(function () {
                     $scope.ctrlCtxt.isLoading = false;
                 });

            } else {
                oddSurveyQuestionnaireTemplateService
                 .updateStaticText(campaign.ODDBusinessUnitID,
                  $scope.questionnaireSection.ODDQuestionnaireID,
                  $scope.questionnaireSection.ODDSectionID,
                  $scope.boxModel)
                 .then(function (createdStaticText) {
                     notificationService.notify('The Static Text has been updated');
                     $state.go('odd.surveyCampaignEdit.section.staticTextEdit', {
                         ODDStaticTextID: createdStaticText.ODDStaticTextID
                     }, {
                         reload: true
                     });
                 }).finally(function () {
                     $scope.ctrlCtxt.isLoading = false;
                 });
            }
        };

        $scope.goToQuestionnaireSection = function () {
            $state.go('odd.surveyCampaignEdit.section', {
                ODDSectionID: questionnaireSection.ODDSectionID,
                ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID
            }, {
                reload: true
            });
        };

        var helpBoxContent =
                'You can use commands to apply style to your text. \n\n' +
                'Here are some of the commands:\n' +
                '\n' +
                '| Style | Command| Result |\n' +
                '|---------|---------|--------------|\n' +
                '| italic | \\*text here\\* | *text here* |\n' +
                '| bold| \\*\\*text here\\*\\* | **text here** |\n' +
                '| bold and italic| \\*\\*\\*text here\\*\\*\\* | ***text here*** |\n' +
                '| link | \\[text](http://www.investpsp.ca) | [text](http://www.investpsp.ca) |\n' +
                '\n' +
                'Header 1 text = # before the text\n' +
                'Header 2 text = ## before the text\n' +
                'Header 3 text = ### before the text\n' +
                'Header 4 text = #### before the text\n' +
                'Header 5 text = ##### before the text\n' +
                'Header 6 text = ###### before the text\n' +
                'Exemple for header 4:\n' +
                '#### header 4\n' +
                '\n' +
                'You can create bulleted and numbered lists:\n' +
                '+ Use "**-**" (hyphen) for a bulleted list\n' +
                '  + Prefix "**-**" with 2 spaces to indent the list (4 spaces for a double indentation)\n' +
                '\n' +
                'Numbered\n' +
                '1. Use "**1.**" for a numbered list\n' +
                '  - You can mix them at different levels\n';
        
        $scope.helpBoxRenderedContent = '<div class="markdown">' + marked(helpBoxContent) + '</div>';
        $scope.moreInfoUrl = 'https://github.com/adam-p/markdown-here/wiki/Markdown-Here-Cheatsheet';
    }
})();